export const checkDiscountIsCheaper = (price?: number, discount?: number) => {
  if (!price || !discount) return false;
  if (price > discount) {
    return true;
  }
  return false;
};
